/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlPostTestingUserResponse
 */
export interface ControlPostTestingUserResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlPostTestingUserResponse
     */
    user_email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPostTestingUserResponse
     */
    user_password: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPostTestingUserResponse
     */
    role: string;
}

/**
 * Check if a given object implements the ControlPostTestingUserResponse interface.
 */
export function instanceOfControlPostTestingUserResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_email" in value;
    isInstance = isInstance && "user_password" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function ControlPostTestingUserResponseFromJSON(json: any): ControlPostTestingUserResponse {
    return ControlPostTestingUserResponseFromJSONTyped(json, false);
}

export function ControlPostTestingUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPostTestingUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_email': json['user_email'],
        'user_password': json['user_password'],
        'role': json['role'],
    };
}

export function ControlPostTestingUserResponseToJSON(value?: ControlPostTestingUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_email': value.user_email,
        'user_password': value.user_password,
        'role': value.role,
    };
}

